import React from 'react';
import { QuestionsPage, FinishPage, ContactsPage } from './SurveyPages';
import { surveyData } from '../surveyData';
import { useVectorSurveyState, vectorSurveyDefaultState } from './surveyStore';
import { SurveysApi } from 'cabmun-public/src/api/index';
import { useClickStreamContext } from '../../../../shared/ClickStream';

function testEmail(email: string) {
  if (/[А-Яа-я]/.test(email)) {
    return 'Русские буквы недопустимы';
  }
  if (/\s/.test(email)) {
    return 'Пробелы недопустимы';
  }
  if (!/\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(email)) {
    return 'Проверьте правильность email';
  }
}

function testPhone(phone: string) {
  if (phone.replace(/[^\d]/g, '').length !== 11) {
    return 'Введите 10 цифр';
  }
}

export const SurveyModal = ({
  ...props
}: {
  page: number;
  nextPage: () => void;
  surveyPrefix: string;
  surveyName: string;
}) => {
  const { values, setValue, errors, setError } = useVectorSurveyState();
  const { logPageEvent } = useClickStreamContext();

  const checkForm = () => {
    let isValid = true;
    if (!values.answer_7.trim()) {
      isValid = false;
      setError('answer_7')('Обязательное поле');
    }
    if (!values.answer_8.trim()) {
      isValid = false;
      setError('answer_8')('Обязательное поле');
    }
    if (!values.answer_9 && !values.answer_10) {
      isValid = false;
      setError('answer_9')('Обязательное поле');
      setError('answer_10')(' ');
    } else {
      if (values.answer_9) {
        const result = testEmail(values.answer_9);
        if (result) {
          setError('answer_9')(result || null);
          setError('answer_10')('');
          isValid = false;
        }
      }
      if (values.answer_10) {
        const result = testPhone(values.answer_10);
        if (result) {
          setError('answer_9')('');
          setError('answer_10')(result || null);
          isValid = false;
        }
      }
    }

    return isValid;
  };

  const prepareResponses = (answers: typeof vectorSurveyDefaultState) => {
    return Object.keys(surveyData)
      .map((key) => ({
        question: surveyData[key as keyof typeof surveyData].question,
        answer: answers[('answer_' + key) as keyof typeof answers] ?? '',
      }))
      .filter((x) => !!x.answer);
  };

  const handleNext = async () => {
    const answers = values;
    if (props.page === 4) {
      if (!checkForm()) {
        return;
      }
      answers.answer_9 = values.answer_9 || ' ';
      answers.answer_10 = values.answer_10 || ' ';
    }
    const responses = prepareResponses(answers);
    try {
      await SurveysApi.sendResponse({ survey_id: props.surveyPrefix, responses, is_multistage_answers: true });
      props.nextPage();
    } catch (e) {
      alert('Не удалось отправить ответ, попробуйте ещё раз');
      return;
    }
    if (props.page >= 1 && props.page < 4) {
      logPageEvent({
        eventType: `${props.surveyPrefix}_user_finished_page_${props.page}`,
        eventInfo: `Опрос|${props.surveyName}: Пользователь ответил на вопросы страницы ${props.page}`,
      });
    }
    if (props.page === 4) {
      logPageEvent({
        eventType: `${props.surveyPrefix}_user_finished_survey`,
        eventInfo: `Опрос|${props.surveyName}: Пользователь прошёл опрос`,
      });
    }
  };

  const pages = {
    1: (
      <>
        <QuestionsPage
          page={1}
          firstQuestion={surveyData['1']}
          firstAnswerValue={values.answer_1}
          setFirstAnswerValue={setValue('answer_1')}
          secondAnswerValue={values.answer_2}
          secondQuestion={surveyData['2']}
          setSecondAnswerValue={setValue('answer_2')}
          handleNext={handleNext}
        />
      </>
    ),
    2: (
      <>
        <QuestionsPage
          page={2}
          firstQuestion={surveyData['3']}
          firstAnswerValue={values.answer_3}
          setFirstAnswerValue={setValue('answer_3')}
          secondAnswerValue={values.answer_4}
          secondQuestion={surveyData['4']}
          setSecondAnswerValue={setValue('answer_4')}
          handleNext={handleNext}
        />
      </>
    ),
    3: (
      <>
        <QuestionsPage
          page={3}
          firstQuestion={surveyData['5']}
          firstAnswerValue={values.answer_5}
          setFirstAnswerValue={setValue('answer_5')}
          secondAnswerValue={values.answer_6}
          secondQuestion={surveyData['6']}
          setSecondAnswerValue={setValue('answer_6')}
          handleNext={handleNext}
        />
      </>
    ),
    4: (
      <>
        <ContactsPage
          page={4}
          name={values.answer_7}
          nameError={errors.answer_7}
          setName={setValue('answer_7')}
          job={values.answer_8}
          jobError={errors.answer_8}
          setJob={setValue('answer_8')}
          email={values.answer_9}
          emailError={errors.answer_9}
          setEmail={setValue('answer_9')}
          phone={values.answer_10}
          phoneError={errors.answer_10}
          setPhone={setValue('answer_10')}
          handleNext={handleNext}
          logPrefix={props.surveyPrefix}
        />
      </>
    ),
    5: (
      <>
        <FinishPage />
      </>
    ),
  };

  return <>{pages[props.page as keyof typeof pages]}</>;
};
